import React, { memo, useContext } from 'react';
import classNames from 'classnames';
import Button from '../button';
import Icon from '../icon';
import Dropdown from './dropdown';
import ConfigContext from '../config-provider/ConfigContext';
const ButtonGroup = Button.Group;
const DropdownButton = function DropdownButton(props) {
    const { prefixCls: customizePrefixCls, type, disabled, onClick, children, className, overlay, trigger, align, visible, onVisibleChange, placement, getPopupContainer, buttonProps, buttonGroupPrefixCls, overlayPlacements, ...restProps } = props;
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const dropdownProps = {
        prefixCls,
        align,
        overlay,
        disabled,
        trigger: disabled ? [] : trigger,
        onVisibleChange,
        placement,
        getPopupContainer,
        overlayPlacements,
    };
    if ('visible' in props) {
        dropdownProps.visible = visible;
    }
    return (React.createElement(ButtonGroup, Object.assign({}, restProps, { prefixCls: buttonGroupPrefixCls, className: classNames(`${prefixCls}-button`, className) }),
        React.createElement(Button, Object.assign({}, buttonProps, { type: type, disabled: disabled, onClick: onClick }), children),
        React.createElement(Dropdown, Object.assign({}, dropdownProps),
            React.createElement(Button, Object.assign({}, buttonProps, { type: type }),
                React.createElement(Icon, { type: "arrow_drop_down" })))));
};
DropdownButton.displayName = 'DropdownButton';
DropdownButton.defaultProps = {
    placement: 'bottomRight',
};
export default memo(DropdownButton);
